import { DayView } from '@devexpress/dx-react-scheduler-material-ui';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  dayViewTimeTableLayout: {
    height: '100%',
    backgroundColor: theme.palette.common.white,
  },
}));

export const DayViewTimeTableLayout = (props: DayView.TimeTableLayoutProps) => {
  const { classes } = useStyles();
  return (
    <DayView.TimeTableLayout
      className={classes.dayViewTimeTableLayout}
      {...props}
    ></DayView.TimeTableLayout>
  );
};
